export default __webpack_public_path__ + "static/media/key1.74b8de6f.png";